import { render, staticRenderFns } from "./BoxOrderList.vue?vue&type=template&id=4fa2dda7&scoped=true&"
import script from "./BoxOrderList.vue?vue&type=script&lang=js&"
export * from "./BoxOrderList.vue?vue&type=script&lang=js&"
import style0 from "./BoxOrderList.vue?vue&type=style&index=0&id=4fa2dda7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2dda7",
  null
  
)

export default component.exports